import { render, staticRenderFns } from "./ClassCard.vue?vue&type=template&id=06ed74ac&scoped=true"
import script from "./ClassCard.vue?vue&type=script&lang=js"
export * from "./ClassCard.vue?vue&type=script&lang=js"
import style0 from "./ClassCard.vue?vue&type=style&index=0&id=06ed74ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ed74ac",
  null
  
)

export default component.exports